import { render, staticRenderFns } from "./AdminBusCompaniesPricesRow.vue?vue&type=template&id=1195dc31&"
import script from "./AdminBusCompaniesPricesRow.vue?vue&type=script&lang=js&"
export * from "./AdminBusCompaniesPricesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports